import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import GameTypeSettingBox from '../GameTypeSettingBox'
import { GetGameTypeSettingDataResponse } from '@/modules/client-setting/type'
import Spinner from '@/common/components/Spinner'

interface GameTypeSettingListingProps {
	gameTypes: GetGameTypeSettingDataResponse[]
	isLoading?: boolean
}

export default function GameTypeSettingListing({
	gameTypes,
	isLoading,
}: GameTypeSettingListingProps) {
	if (isLoading) return <Spinner />

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`ตั้งค่าเกมที่โชว์บนหน้าเว็บ`}
					description="ตั้งค่าเกมที่โชว์บนหน้าเว็บ"
				/>
			</div>
			<Separator />
			{gameTypes.map((gameType) => (
				<GameTypeSettingBox key={gameType.id} data={gameType} />
			))}
		</div>
	)
}
